export default "__VITE_ASSET__34nFokj8__"